import { faAngleDoubleUp, faAngleUp, faFire, faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FunctionComponent, useEffect, useState } from "react";
import styled from "styled-components";
import ITrainer from "types/Trainer";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

type OwnProps = {
  trainer: ITrainer;
};

type Props = OwnProps;

const mainBonuses = ["Training Reward (All)", ""];

enum MainBonus {
  "Training Reward (All)" = "Training Reward (All)",
  "Training Reward (Attribute)" = "Training Reward (Attribute)",
  "Stamina (ALL) Down" = "Stamina Down",
  "Sp. Training Reward Up" = "Sp. Training Reward Up",
}

const icons = {
  [MainBonus["Sp. Training Reward Up"]]: faFire,
  [MainBonus["Training Reward (All)"]]: faAngleDoubleUp,
  [MainBonus["Training Reward (Attribute)"]]: faAngleUp,
  [MainBonus["Stamina (ALL) Down"]]: faHeart,
};

const Styled = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: center;

  > div {
    margin-right: 8px;
    transition: 200ms;

    &:hover {
      color: #00000061;
    }
  }
`;

const TrainerBonusType: FunctionComponent<Props> = ({ trainer }) => {
  const [main, setMain] = useState<MainBonus>(null);

  const devBonuses = trainer.devBonus[1];

  const updateMainBonus = () => {
    const bonus = trainer.devBonus[5].find((b) => !trainer.devBonus[4].includes(b));
    const mainBonuses = [];

    if (!bonus) {
      return null;
    }

    if (bonus.includes("STM")) {
      mainBonuses.push(MainBonus["Stamina (ALL) Down"]);
    } else if (bonus.includes("Sp. Training Reward")) {
      mainBonuses.push(MainBonus["Sp. Training Reward Up"]);
    } else if (bonus.includes("Training Reward")) {
      if (bonus.includes("All")) {
        mainBonuses.push(MainBonus["Training Reward (All)"]);
      } else if (!bonus.includes("%")) {
        mainBonuses.push(MainBonus["Training Reward (Attribute)"]);
      }
    }

    setMain(mainBonuses[0]);
  };

  useEffect(() => {
    updateMainBonus();
  }, []);

  const icon = icons[main];

  if (!icon) {
    return null;
  }

  return (
    <Styled>
      <div style={{ width: 0, visibility: "hidden" }}>
        <FontAwesomeIcon icon={icons[MainBonus["Sp. Training Reward Up"]]} />
      </div>

      <Tippy content={main}>
        <div>
          <FontAwesomeIcon icon={icon} />
        </div>
      </Tippy>
    </Styled>
  );
};

export default TrainerBonusType;
